// src/utils/api.js

import Airtable from 'airtable';

const base = new Airtable({ apiKey: process.env.REACT_APP_AIRTABLE_API_KEY }).base(
  process.env.REACT_APP_AIRTABLE_BASE_ID
);

export async function saveEstimate(payload) {
  try {
	const table = base('Inbox'); // Ensure 'Inbox' matches your Airtable table name
	const record = await table.create([
	  {
		fields: payload,
	  },
	]);
	return record;
  } catch (error) {
	console.error('Error saving to Airtable:', error);
	throw error;
  }
}
